import React from "react";

import Store from "@/stores";

export default React.createContext<Store>(undefined!);
